import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ConversionFlagKey = {
  SKIP_CHECKOUT_RATES_THIRD_PARTY_DEPENDENCIES: featureFlagKey(
    "skip-checkout-rates-third-party-dependencies",
  ), // Skip third party dependencies when fetching rates
  PACKAGE_PROTECTION_PLUS_ID_COLLECTION_ENABLED: featureFlagKey(
    "package-protection-plus-id-collection-enabled",
  ), // Show the PP+ third-party-insurer confirmation-page messaging (title/subtitle + insurer review step). Default off.
  CHECKOUT_FALLBACK_RATE_CARD_REDIS: featureFlagKey(
    "checkout-fallback-rate-card-redis",
  ), // System rollout dial for the Redis layer of the checkout fallback rate card: when on, US reads check Redis first and backfill from Congo on a miss, US writes mirror into Redis, and international cards (which live only in Redis) are read/written. Default OFF.
  CHECKOUT_FALLBACK_RATE_CARD_CONGO: featureFlagKey(
    "checkout-fallback-rate-card-congo",
  ), // System dial for the durable (Mongo/CongoDB/CRDB) US fallback rate card layer: when on, US reads fall back to it on a Redis miss and US writes persist to it. Default ON — turning it off moves US fully onto Redis. International never uses this layer.
  COMMERCE_CLOUD_DELIVERY_ESTIMATES: featureFlagKey(
    "commerce-cloud-delivery-estimates",
  ), // Gate + kill switch for the commerce-cloud checkout delivery-estimates RPC. Per team, default OFF.
} as const;
